export default __webpack_public_path__ + "static/media/timeline.af77345a.jpg";